import { LayoutGrid, Grid2x2, Bath, Expand, Layers, ShieldCheck, TrendingUp, Hammer, ArrowUpRight } from "lucide-react";
import { scrollToId } from "../data/site";
import { FadeUp, SectionHead } from "./motion";
import { useLang } from "../context/LangContext";

const ICONS = { LayoutGrid, Grid2x2, Bath, Expand, Layers, ShieldCheck, TrendingUp, Hammer };

export const Prestations = () => {
  const { S } = useLang();
  return (
    <section id="prestations" data-testid="prestations-section" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <SectionHead
            eyebrow={S.prestations.eyebrow}
            title={S.prestations.title}
            subtitle={S.prestations.subtitle}
          />
          <FadeUp delay={0.2}>
            <a
              href="#devis"
              onClick={(e) => {
                e.preventDefault();
                scrollToId("#devis");
              }}
              data-testid="prestations-cta-devis"
              className="group hidden lg:inline-flex items-center gap-2 text-sm font-semibold text-sky-600 hover:text-sky-700 transition-colors"
            >
              {S.prestations.cta}
              <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </FadeUp>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {S.prestations.items.map((p, i) => {
            const Icon = ICONS[p.icon];
            return (
              <FadeUp key={p.id} delay={(i % 4) * 0.08}>
                <article
                  data-testid={`prestation-card-${p.id}`}
                  className="group h-full rounded-2xl border border-slate-200 bg-white p-8 transition-all duration-500 hover:-translate-y-1.5 hover:border-sky-300 hover:shadow-2xl hover:shadow-sky-100"
                >
                  <div className="flex items-start justify-between">
                    <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-sky-50 text-sky-600 transition-colors duration-500 group-hover:bg-sky-600 group-hover:text-white">
                      <Icon className="w-6 h-6" />
                    </span>
                    <span className="font-tech text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-400 pt-1">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <h3 className="mt-6 font-display text-xl font-semibold tracking-tight text-slate-900">{p.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-slate-600">{p.desc}</p>
                  <span className="mt-6 inline-flex items-center rounded-full bg-slate-100 px-3 py-1 font-tech text-[10px] font-semibold uppercase tracking-[0.16em] text-slate-500 transition-colors duration-500 group-hover:bg-sky-50 group-hover:text-sky-700">
                    {p.tag}
                  </span>
                </article>
              </FadeUp>
            );
          })}
        </div>
      </div>
    </section>
  );
};
